import React, { useMemo, useState } from 'react';

import { SearchTerm } from 'shared/models/search';

import { TextfieldWithChips } from '../core-ui/textfield-with-chips';
import { useSchoolNames } from '../hooks/use-school-names';
import { renderOption } from './search-autocomplete-option';
import { useSearchPresets } from './use-search-presets';

interface SearchSchoolTextFieldProps {
    onInputChange?: (value: string) => void;
    chips: SearchTerm[];
    readonly: boolean;
    onChange: (chips: SearchTerm[]) => void;
    getChipFromString: (text: string, dataSource?: boolean) => SearchTerm;
    getStringFromChip: (chip: SearchTerm) => string;
    getChipStyle?: (value: SearchTerm) => React.CSSProperties;
    prefixChips?: JSX.Element;
}

export const SearchSchoolTextField: React.FC<SearchSchoolTextFieldProps> = ({
    readonly,
    prefixChips,
    chips,
    onChange,
    getChipStyle,
    getChipFromString,
    getStringFromChip
}) => {
    const [inputValue, setInputValue] = useState<string>('');
    const { schoolNames, loading } = useSchoolNames(inputValue);
    const { searchPresets, getGroupSearchTerms } = useSearchPresets();

    const options = useMemo(() => {
        const schoolNameOpts: Array<SearchTerm & { count?: number }> = schoolNames?.map((school) => ({
            count: school.count,
            isPreset: false,
            label: school.name,
            value: school.url
        }));
        return getGroupSearchTerms('schools', schoolNameOpts);
    }, [schoolNames, searchPresets]);

    return (
        <TextfieldWithChips
            readonly={readonly}
            prefixChips={prefixChips}
            chips={chips}
            options={options}
            hintText="Add School"
            onChange={onChange}
            getChipStyle={getChipStyle}
            getChipFromString={getChipFromString}
            getStringFromChip={getStringFromChip}
            onInputChange={setInputValue}
            renderOption={renderOption}
            loading={loading}
        />
    );
};
